module.exports = __webpack_public_path__ + "img/voucher-default.8553202a.jpg";